import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import MediaQuery from 'react-responsive';
import classNames from 'classnames';
import { IconButton, ICONS, IFRAME_SCROLL_ELEMENT_ID } from 'conversional-components';
import { boxes, ComponentClass } from 'conversional-theme';
import { MESSAGETYPES, sendToHost } from 'conversional-iframe-communication';
import { Events, JourneysSelectors, TrackingActions, useAppDispatch, useAppSelector, } from 'conversional-journey';
import { getStyles } from './ModalDesign.styles';
var TOOLTIPS = {
    CLOSE: 'common.close_tooltip',
    RESTART: 'common.restart_tooltip',
};
var ModalComponent = function (_a) {
    var onClose = _a.onClose, hideResetButton = _a.hideResetButton, hideCloseButton = _a.hideCloseButton, children = _a.children, closeOnBackdropClick = _a.closeOnBackdropClick, onAnimationComplete = _a.onAnimationComplete, _b = _a.windowStyles, windowStyles = _b === void 0 ? {} : _b, _c = _a.containerStyles, containerStyles = _c === void 0 ? {} : _c, _d = _a.modalStyles, modalStyles = _d === void 0 ? {} : _d, _e = _a.closeButtonContainerStyles, closeButtonContainerStyles = _e === void 0 ? {} : _e;
    var _f = useState(true), show = _f[0], setShow = _f[1];
    var theme = useAppSelector(JourneysSelectors.selectTheme);
    var actionTooltips = useAppSelector(function (state) {
        return JourneysSelectors.selectTranslationKeys(state, [TOOLTIPS.RESTART, TOOLTIPS.CLOSE]);
    });
    var dispatch = useAppDispatch();
    var trackEvent = function (event) { return dispatch(TrackingActions.event(event)); };
    var variants = {
        show: {
            transition: {
                ease: [0.465, 0.183, 0.153, 0.946],
                duration: 0.3,
            },
            opacity: 1,
        },
        exit: {
            transition: {
                ease: [0.465, 0.183, 0.153, 0.946],
                duration: 0.1,
            },
            opacity: 0,
        },
    };
    var close = function () {
        setShow(false);
        trackEvent(Events.JOURNEY_CLOSE);
        onClose();
    };
    var onReset = function () {
        trackEvent(Events.JOURNEY_RESTART);
        sendToHost.publish(MESSAGETYPES.JOURNEY_RESTART);
    };
    var handleBackdropClick = function (event) {
        return closeOnBackdropClick && event.target === event.currentTarget && close();
    };
    var classes = getStyles(theme);
    // TODO: Trigger animations on mount
    return (_jsx(AnimatePresence, { onExitComplete: close, children: show && (_jsx(motion.div, { className: classNames(classes.window, ComponentClass(windowStyles)), onAnimationComplete: onAnimationComplete, animate: "show", exit: "exit", onClick: handleBackdropClick, variants: variants, id: "conversional-posed-modal", children: _jsx(motion.div, { animate: "show", variants: variants, id: IFRAME_SCROLL_ELEMENT_ID, className: classNames(classes.PosedModal, ComponentClass(containerStyles)), children: _jsxs("div", { className: classNames(classes.modal, ComponentClass(modalStyles)), children: [_jsxs("div", { className: classNames(classes.closeButtonContainer, ComponentClass(closeButtonContainerStyles)), children: [_jsxs(MediaQuery, { maxWidth: boxes.md.max, children: [!hideResetButton && (_jsx(IconButton, { backgroundColor: "rgba(9, 45, 66, 0.00)", backgroundHoverColor: "rgba(9, 45, 66, 0.08)", color: theme.colors.textLight, hoverColor: theme.colors.text, icon: ICONS.backward, tooltip: actionTooltips[TOOLTIPS.RESTART], close: onReset })), !hideCloseButton && (_jsx(IconButton, { backgroundColor: "rgba(9, 45, 66, 0.00)", backgroundHoverColor: "rgba(9, 45, 66, 0.08)", color: theme.colors.textLight, hoverColor: theme.colors.text, tooltip: actionTooltips[TOOLTIPS.CLOSE], close: function () {
                                                setShow(false);
                                            } })), ' '] }), _jsxs(MediaQuery, { minWidth: boxes.lg.min, children: [!hideResetButton && (_jsx(IconButton, { backgroundColor: "rgba(9, 45, 66, 0.00)", backgroundHoverColor: "rgba(9, 45, 66, 0.08)", color: theme.colors.textLight, hoverColor: theme.colors.text, icon: ICONS.backward, tooltip: actionTooltips[TOOLTIPS.RESTART], close: onReset })), !hideCloseButton && (_jsx(IconButton, { backgroundColor: "rgba(9, 45, 66, 0.00)", backgroundHoverColor: "rgba(9, 45, 66, 0.08)", color: theme.colors.textLight, hoverColor: theme.colors.text, tooltip: actionTooltips[TOOLTIPS.CLOSE], close: function () {
                                                setShow(false);
                                            } }))] })] }), children] }) }) }, "conversional-journey-posed-modal")) }));
};
export default ModalComponent;
